import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const PURPLE = "#7c3aed";

export const CARD_SX = {
  p: 2,
  borderRadius: 3,
  boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
  border: "1px solid #eef0f4",
};

export default function AnalyticsPageShell({ title, subtitle, filters, children }) {
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, color: PURPLE, mb: 0.5 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      )}
      {filters && (
        <Paper sx={{ ...CARD_SX, mb: 2 }}>{filters}</Paper>
      )}
      {children}
    </Box>
  );
}
